import withStyles from '@material-ui/core/styles/withStyles';
import moment from 'moment';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import SchedulerDayPopover from 'Components/Modals/ClientSchedulerModal/Default/MonthlyCalendar/SchedulerDayPopover';
import usePopoverState from 'Hooks/usePopoverState';
import {
  useClientSchedulerDispatchContext, useClientSchedulerStateContext, fetchDataFromLinkQueryParam, setNewLinkQueryParam,
} from 'Context/NewClientSchedulerContext';
import fr from 'facet-rest';
import SchedulerDayButton from './SchedulerDayButton';

const styles = theme => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: 'calc(100% /7)',
    padding: theme.spacing(1),
  },
  dateContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
  },
  notInCurrentMonth: {
    display: 'none',
  },
});

const MobileSchedulerDay = ({
  classes,
  day,
  date,
  onDayNumberClick,
  currentMonth,
  items,
}) => {
  const { currentCollection } = useClientSchedulerStateContext();
  const dispatch = useClientSchedulerDispatchContext();
  const {
    open,
    anchorEl,
    openPopover,
    handleClose,
    handleEnter,
  } = usePopoverState({});

  const availabilityPeriodResource = currentCollection.resources().head();
  const inCurrentMonth = currentMonth.isSame(date, 'month');
  const [availabilityDayItem] = items;

  if (!availabilityDayItem) {
    return (
      <div
        className={classNames(classes.root)}
      >
        <div className={classNames(classes.dateContainer)} />
      </div>
    );
  }

  const { resource } = availabilityDayItem;
  const capacity = parseInt(resource.attr('capacity'), 10);
  const meetingAvailabilities = resource.attr('meetingAvailabilities').resources().list();


  const handleClickAvailableTime = (meetingAvailabilityResource) => {
    setNewLinkQueryParam(dispatch, meetingAvailabilityResource.relationship(fr.relationships.scheduleCalendarEvent.name).link('related').url());
    dispatch({ type: 'setPrevLink', prevLink: availabilityPeriodResource.link('self').url() });
    dispatch({
      type: 'setConfirmTime',
      selectedMeetingStart: meetingAvailabilityResource.attr('startTime'),
      selectedMeetingEnd: meetingAvailabilityResource.attr('endTime'),
      bufferDuration: meetingAvailabilityResource.attr('bufferLength'),
    });
    fetchDataFromLinkQueryParam(dispatch);
  };

  const handleDayNumberClick = (event) => {
    onDayNumberClick(date);
    openPopover(event);
  };

  // We should show all days when the EveningWeekends feature is enable, so let's force the SchedulerDayButton component to display the same as the weekdays
  const showAllDays = true;
  return (
    <div
      className={classNames(classes.root)}
    >
      <div
        className={classNames(classes.dateContainer, {
          [classes.notInCurrentMonth]: !inCurrentMonth,
        })}
        test="client-mobile-scheduler-month-day"
      >
        <SchedulerDayButton
          capacity={capacity}
          day={day}
          handleDayNumberClick={handleDayNumberClick}
          inCurrentMonth={inCurrentMonth}
          test="client-mobile-scheduler-day-number"
          isWeekday={showAllDays}
        />
      </div>
      <SchedulerDayPopover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        onEnter={handleEnter}
        onClickAvailableTime={handleClickAvailableTime}
        meetingAvailabilities={meetingAvailabilities}
      />
    </div>
  );
};

MobileSchedulerDay.defaultProps = {
  day: null,
  date: null,
  onDayNumberClick: null,
  items: [],
};

MobileSchedulerDay.propTypes = {
  classes: PropTypes.object.isRequired,
  day: PropTypes.number,
  date: PropTypes.instanceOf(moment),
  onDayNumberClick: PropTypes.func,
  currentMonth: PropTypes.object.isRequired,
  items: PropTypes.array,
};

export default withStyles(styles)(MobileSchedulerDay);
